import { fetcher } from '#lib/backendFetcher';

const BASE = '/api/v1/email/signatures';

/**
 * Fetches all email signatures for the organization.
 * @returns {Promise<{data: Array<Object>, error: null}>}
 */
export const fetchAllSignatures = async () => {
	const { signatures } = await fetcher(BASE);
	return { data: signatures, error: null };
};

/**
 * Fetches a single email signature by its ID.
 * @param {string} id - UUID of the signature
 * @returns {Promise<{data: Object, error: null}>}
 */
export const fetchSignatureById = async (id) => {
	const data = await fetcher(`${BASE}/${id}`);
	return { data, error: null };
};

/**
 * Creates a new email signature.
 * @param {Object} params
 * @param {string} params.name - Name of the signature
 * @param {string} params.content - HTML content of the signature
 * @param {boolean} params.isDefault - Whether to set this signature as the default
 * @returns {Promise<{data: Object, error: null}>}
 */
export const createSignature = async ({ name, content, isDefault }) => {
	const data = await fetcher(BASE, {
		method: 'POST',
		body: { name, content, isDefault },
	});
	return { data, error: null };
};

/**
 * Updates an existing email signature.
 * @param {string} id - UUID of the signature
 * @param {Object} updates - Fields to update (name, content, isDefault)
 * @returns {Promise<{data: Object, error: null}>}
 */
export const updateSignature = async (id, updates) => {
	const data = await fetcher(`${BASE}/${id}`, {
		method: 'PATCH',
		body: updates,
	});
	return { data, error: null };
};

/**
 * Deletes an email signature.
 * @param {string} id - UUID of the signature
 * @returns {Promise<{error: null}>}
 */
export const deleteSignature = async (id) => {
	await fetcher(`${BASE}/${id}`, { method: 'DELETE' });
	return { error: null };
};
